<template>
  <contact-page-content
    v-if="course"
    title="Obtenir le programme de la formation"
  >
    <template #subtitle>
      <figure class="hidden items-center gap-4 md:flex">
        <app-user-avatar
          v-if="course.teacher"
          :avatar-url="course.teacher.avatar_url"
          :name="course.teacher.full_name"
          :size="60"
          tile
        />

        <figcaption>
          <p class="mb-1 text-lg font-bold">
            {{ course.title }}
          </p>
          <p v-if="course.teacher">
            <strong>{{ course.teacher.full_name }}</strong
            >,
            <span class="mr-2">{{ course.teacher.job }}</span>
            <teacher-companies-logos
              :companies="course.teacher.companies"
              :height="26"
            />
          </p>
        </figcaption>
      </figure>
    </template>

    <contact-page-content-feature-list :list="features" />
  </contact-page-content>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

import ContactPageContent from "~/pages/contact/_includes/components/content/contact-page-content.vue";
import ContactPageContentFeatureList from "~/pages/contact/_includes/components/content/contact-page-content-feature-list.vue";
import { useCoursePageData } from "~/pages/courses/[slug]/_includes/composables/course-page.data";
import type { ContactFlowMetadata } from "~~/model/analytics.model";

const properties = defineProps<{
  metadata: ContactFlowMetadata;
}>();

const { course } = await useCoursePageData(properties.metadata.origin_page_id!);

const features: { label: I18nMessage; icon: string }[] = [
  {
    label: "Les expériences partagées par le trainer",
    icon: "ph:users-four",
  },
  {
    label: "Les ateliers et cas pratiques",
    icon: "ph:shield-chevron",
  },
  {
    label: "Les méthodes et concepts théoriques",
    icon: "ph:rocket-launch",
  },
];
</script>
